import { useMutation } from "@tanstack/react-query";
import { createFloorPlanMemoText } from "~/_legacy/apis/create-floor-plan-memo-text";
import { isNullish } from "~/_legacy/utils/compare";

export const CREATE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY = "createFloorPlanMemoText";

export function useCreateFloorPlanMemoText({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [CREATE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({
      floorPlanId,
      content,
      position,
      style,
    }: {
      floorPlanId: number;
      content: string;
      position: { x: number; y: number };
      style: {
        color: string;
        width: number;
        opacity: number;
        fontSize: number;
        hasStroke: boolean;
        rotation?: number;
      };
    }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return createFloorPlanMemoText({
        branchUid,
        branchVersionId,
        floorPlanId,
        content,
        position,
        style,
      });
    },
  });

  return {
    createFloorPlanMemoText: mutateAsync,
  };
}
